import React from 'react';
import { Link, useLocation  } from 'react-router-dom/cjs/react-router-dom.min';
import { navItems } from '../../../../databases/navItems';
import './Navbar.scss';

export const Navbar = () => {
    const location = useLocation();

    return (
        <div className="navbar">
            {navItems.map((navItem, index) => (
                <Link
                    key={index}
                    to={`${navItem.path}`}
                    className={`${location.pathname === navItem.path ? 'active' : ''}`}
                >
                    {navItem.name}
                </Link>
            ))}
        </div>
    )
}